import PropTypes from "prop-types"
import React, { useEffect, useState, useMemo } from "react"
import moment from "moment"
import {
  Badge,
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap"
import { Link } from "react-router-dom"

import classNames from "classnames"

//import Charts
import StackedColumnChart from "./StackedColumnChart"

// //import action
// import { getChartsData as onGetChartsData } from "../../store/actions"

// Image
import modalimage1 from "../../assets/images/product/img-7.png"
import modalimage2 from "../../assets/images/product/img-4.png"

// Pages Components
import WelcomeComp from "./WelcomeComp"
import MonthlyEarning from "./MonthlyEarning"
// import SocialSource from "./SocialSource"
// import ActivityComp from "./ActivityComp"
// import TopCities from "./TopCities"
import LatestTranaction from "./LatestTranaction"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"

//redux
import { useDispatch } from "react-redux"

import {
  useCampusVirtualDataDashboardCobranza,
  useCampusVirtualIdCampus,
  useCampusVirtualNombreCampusSeleccionado,
  useCampusVirtualIsLoading,
  useCampusVirtualDataDashboardUltimosRecibos,
} from "store/selectors"

import {
  getCampusVirtualCartera as onGetCartera,
  getCampusVirtualUltimosRecibos as onGetUltimosRecibos,
} from "store/actions"
import { data } from "autoprefixer"

const Dashboard_Alumnos = props => {
  //meta title
  document.title = "Dashboard Alumnos| CampusVirtual"

  const dispatch = useDispatch()
  const [totalxCobrarMes, setTotalxCobrarMes] = useState(0)
  const [porcentajeCobradoMes, setPorcentajeCobradoMes] = useState(0)
  const [cobradoMes, setCobradoMes] = useState(0)
  const [ultimosRecibos, setUltimosRecibos] = useState([])

  const dataCobranza = useCampusVirtualDataDashboardCobranza()
  const idCampus = useCampusVirtualIdCampus()
  const nombreCampusActual = useCampusVirtualNombreCampusSeleccionado()
  const isLoading = useCampusVirtualIsLoading()
  const dataUltimosRecibos = useCampusVirtualDataDashboardUltimosRecibos()

  const yearData = [
    {
      name: "Activo",
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    {
      name: "Baja",
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    {
      name: "Titulado",
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
  ]

  const latestTransaction = [
    {
      orderId: "#SK2545",
      billingName: "Jacob Hunter",
      orderDate: "04 Oct, 2019",
      total: "$392",
      paymentStatus: "Paid",
      methodIcon: "fab fa-cc-paypal",
      paymentMethod: "Paypal",
    },
    {
      orderId: "#SK2544",
      billingName: "Ronald Taylor",
      orderDate: "04 Oct, 2019",
      total: "$404",
      paymentStatus: "Refund",
      methodIcon: "fab fa-cc-visa",
      paymentMethod: "Visa",
    },
    {
      orderId: "#SK2543",
      billingName: "Barry Dick",
      orderDate: "05 Oct, 2019",
      total: "$412",
      paymentStatus: "Paid",
      methodIcon: "fab fa-cc-mastercard",
      paymentMethod: "Mastercard",
    },
    {
      orderId: "#SK2542",
      billingName: "Juan Mitchell",
      orderDate: "06 Oct, 2019",
      total: "$384",
      paymentStatus: "Paid",
      methodIcon: "fab fa-cc-paypal",
      paymentMethod: "Paypal",
    },
    {
      orderId: "#SK2541",
      billingName: "Jamal Burnett",
      orderDate: "07 Oct, 2019",
      total: "$380",
      paymentStatus: "Chargeback",
      methodIcon: "fab fa-cc-visa",
      paymentMethod: "Visa",
    },
    {
      orderId: "#SK2540",
      billingName: "Neal Matthews",
      orderDate: "07 Oct, 2019",
      total: "$400",
      paymentStatus: "Paid",
      methodIcon: "fab fa-cc-mastercard",
      paymentMethod: "Mastercard",
    },
  ]

  const columns = useMemo(
    () => [
      {
        header: () => <input type="checkbox" className="form-check-input" />,
        accessorKey: "id_Recibo_Pago",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return <input type="checkbox" className="form-check-input" />
        },
      },
      {
        header: "Folio",
        accessorKey: "Folio_Campus",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <Link to="#" className="text-body fw-bold">
              {cellProps.row.original.Folio_Campus}
            </Link>
          )
        },
      },
      {
        header: "Alumno",
        accessorKey: "Nombre",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Fecha",
        accessorKey: "Fecha_Recibo",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <React.Fragment>
              {moment(cellProps.row.original.Fecha_Recibo).format(
                "DD MMM, YYYY"
              )}
            </React.Fragment>
          )
        },
      },
      {
        header: "Total",
        accessorKey: "Cantidad_Recibo",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <React.Fragment>
              {cellProps.row.original.Cantidad_Recibo.toLocaleString("es-MX", {
                style: "currency",
                currency: "MXN",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </React.Fragment>
          )
        },
      },
      {
        header: "Status",
        accessorKey: "Cancelado",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <Badge
              className={
                "font-size-11 badge-soft-" +
                (!cellProps.row.original.Cancelado
                  ? "success"
                  : "danger" && cellProps.row.original.Cancelado === "Cancel"
                  ? "warning"
                  : "danger")
              }
            >
              {!cellProps.row.original.Cancelado ? "Activo" : "Cancelado"}
            </Badge>
          )
        },
      },
      {
        header: "Método Pago",
        accessorKey: "Nombre_Forma_Pago",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <span>
              <i
                className={
                  cellProps.row.original.Nombre_Forma_Pago === "Paypal"
                    ? "fab fa-cc-paypal me-1"
                    : "" || cellProps.row.original.Nombre_Forma_Pago === "COD"
                    ? "fab fas fa-money-bill-alt me-1"
                    : "" ||
                      cellProps.row.original.Nombre_Forma_Pago === "Mastercard"
                    ? "fab fa-cc-mastercard me-1"
                    : "" || cellProps.row.original.Nombre_Forma_Pago === "Visa"
                    ? "fab fa-cc-visa me-1"
                    : ""
                }
              />{" "}
              {cellProps.row.original.Nombre_Forma_Pago}
            </span>
          )
        },
      },
      {
        header: "Detalles",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "view",
        cell: cellProps => {
          return (
            <Button
              type="button"
              color="primary"
              className="btn-sm btn-rounded"
              onClick={() => toggleViewModal()}
            >
              Ver Detalles
            </Button>
          )
        },
      },
    ],
    []
  )

  const reports = [
    {
      title: "xCobrar",
      iconClass: "bx-money",
      description: totalxCobrarMes.toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }),
    },
    { title: "+30", iconClass: "bx-archive-in", description: "$35, 723" },
    {
      title: "+90",
      iconClass: "bx-error-alt",
      description: "$16.2",
    },
  ]

  const [periodData, setPeriodData] = useState(yearData)
  const [periodType, setPeriodType] = useState("yearly")

  const onChangeChartPeriod = pType => {
    setPeriodType(pType)
    setPeriodData(yearData)
    //dispatch(onGetChartsData(pType))
  }

  useEffect(() => {
    if (isLoading) {
      setPeriodData(yearData)
      setUltimosRecibos([])
    }
  }, [isLoading])

  // Ejecutar solo cuando idCampus cambie
  useEffect(() => {
    if (idCampus > 0) {
      dispatch(
        onGetCartera({
          nombreSolicitud: "getcarteraxidgruposervicios",
          sListaIdCampus: idCampus,
          ano: new Date().getFullYear(),
          idGrupoServicios: 1,
        })
      )
    }
  }, [dispatch, idCampus])

  // Ejecutar solo cuando idCampus cambie
  useEffect(() => {
    if (idCampus > 0) {
      dispatch(
        onGetUltimosRecibos({
          nombreSolicitud: "getdataultimosrecibos",
          idCampus: idCampus,
        })
      )
    }
  }, [dispatch, idCampus])

  useEffect(() => {
    if (dataCobranza && dataCobranza.length > 0) {
      const currentMonth = new Date().getMonth() + 1 // Mes actual
      const objMes = dataCobranza.find(objeto => objeto.Mes === currentMonth)

      if (objMes) {
        const meta = objMes.Total_Cantidad - objMes.Total_Cancelados
        const constxPagar = meta - objMes.Total_Saldados
        const porcentajeCobrado = (objMes.Total_Saldados * 100) / meta

        setTotalxCobrarMes(meta | 0)
        setPorcentajeCobradoMes(porcentajeCobrado | 0)
        setCobradoMes(objMes.Total_Saldados | 0)
      } else {
        // Opcional: valores por defecto cuando no hay datos del mes
        setTotalxCobrarMes(0)
        setPorcentajeCobradoMes(0)
        setCobradoMes(0)
      }
    } else {
      // También puedes resetear valores si dataCobranza está vacía
      setTotalxCobrarMes(0)
      setPorcentajeCobradoMes(0)
      setCobradoMes(0)
    }
  }, [dataCobranza])

  useEffect(() => {
    if (Array.isArray(dataCobranza) && dataCobranza.length > 0) {
      // Inicializar los arreglos para cada serie con 12 meses en cero
      let serieA = Array(12).fill(0)
      let serieB = Array(12).fill(0)
      let serieC = Array(12).fill(0)

      // Crear un mapa de datos por mes para acceso rápido
      const dataMap = new Map()
      dataCobranza.forEach(dato => {
        if (dato && typeof dato.Mes === "number") {
          dataMap.set(dato.Mes - 1, dato) // Guardar con índice base 0
        }
      })

      // Rellenar los datos mes a mes, asegurando que la suma sea 100
      for (let i = 0; i < 12; i++) {
        if (dataMap.has(i)) {
          const dato = dataMap.get(i)

          // Validación segura de propiedades numéricas
          const totalCantidad = dato.Total_Cantidad || 1 // Evitar división por cero

          const totalSaldados = dato.Total_Saldados || 0
          const totalCanceladosSaldados = dato.Total_Cancelados_Saldados || 0
          const totalNoSaldados = dato.Total_No_Saldados || 0
          const totalCanceladosNoSaldados =
            dato.Total_Cancelados_No_Saldados || 0
          const totalCancelados = dato.Total_Cancelados || 0

          let pagado =
            ((totalSaldados - totalCanceladosSaldados) / totalCantidad) * 100 ||
            0

          let xCobrar =
            ((totalNoSaldados - totalCanceladosNoSaldados) / totalCantidad) *
              100 || 0

          let cancelado = (totalCancelados / totalCantidad) * 100 || 0

          // Ajuste para que la suma de los porcentajes sea exactamente 100
          let total = pagado + xCobrar + cancelado
          if (total !== 100) {
            const diferencia = 100 - total
            pagado += diferencia // Puedes distribuirlo diferente si lo prefieres
          }

          serieA[i] = parseFloat(pagado.toFixed(2))
          serieB[i] = parseFloat(xCobrar.toFixed(2))
          serieC[i] = parseFloat(cancelado.toFixed(2))
        }
      }

      // Construir el arreglo final
      setPeriodData([
        {
          name: "Pagado",
          data: serieA,
        },
        {
          name: "xCobrar",
          data: serieB,
        },
        {
          name: "Cancelado",
          data: serieC,
        },
      ])
    } else {
      // Si no hay datos, aseguramos limpiar el gráfico con ceros
      setPeriodData([
        { name: "Pagado", data: Array(12).fill(0) },
        { name: "xCobrar", data: Array(12).fill(0) },
        { name: "Cancelado", data: Array(12).fill(0) },
      ])
    }
  }, [dataCobranza])

  useEffect(() => {
    if (dataUltimosRecibos && dataUltimosRecibos.length > 0) {
      setUltimosRecibos(dataUltimosRecibos)
    }
  }, [dataUltimosRecibos])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          />
          <Row>
            <Col xl="4">
              <WelcomeComp
                cobrado={cobradoMes}
                noRecibos={125}
                isLoading={isLoading}
              />
              <MonthlyEarning
                Total_xCobrar={totalxCobrarMes}
                porcentaje={porcentajeCobradoMes}
                isLoading={isLoading}
              />
            </Col>
            <Col xl="8">
              <Row>
                {(reports || [])?.map((report, key) => (
                  <Col md="4" key={"_col_" + key}>
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                              {report.title}
                            </p>
                            {isLoading ? (
                              <React.Fragment>
                                <h4 className="mb-0 placeholder-glow">
                                  <span className="placeholder col-12 placeholder-lg bg-primary"></span>
                                </h4>
                              </React.Fragment>
                            ) : (
                              <h4 className="mb-0">{report.description}</h4>
                            )}

                            {/* <h4 className="mb-0">{report.description}</h4> */}
                          </div>
                          <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                            <span className="avatar-title rounded-circle bg-primary">
                              <i
                                className={
                                  "bx " + report.iconClass + " font-size-24"
                                }
                              ></i>
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>

              <Card>
                <CardBody>
                  <div className="d-sm-flex flex-wrap">
                    <h4 className="card-title mb-4">
                      Alumnos {nombreCampusActual}
                    </h4>
                    <div className="ms-auto">
                      <ul className="nav nav-pills">
                        <li className="nav-item">
                          {/* <Link
                            to="#"
                            className={classNames(
                              { active: periodType === "weekly" },
                              "nav-link"
                            )}
                            onClick={() => {
                              onChangeChartPeriod("weekly")
                            }}
                            id="one_month"
                          >
                            Semana
                          </Link>{" "}
                        </li>
                        <li className="nav-item">
                          <Link
                            to="#"
                            className={classNames(
                              { active: periodType === "monthly" },
                              "nav-link"
                            )}
                            onClick={() => {
                              onChangeChartPeriod("monthly")
                            }}
                            id="one_month"
                          >
                            Mes
                          </Link> */}
                        </li>
                        <li className="nav-item">
                          <Link
                            to="#"
                            className={classNames(
                              { active: periodType === "yearly" },
                              "nav-link"
                            )}
                            onClick={() => {
                              onChangeChartPeriod("yearly")
                            }}
                            id="one_month"
                          >
                            Año
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* <div className="clearfix"></div> */}
                  <StackedColumnChart
                    periodData={periodData}
                    dataColors='["--bs-primary", "--bs-warning", "--bs-success"]'
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg="12">
              <LatestTranaction
                latestTransaction={ultimosRecibos}
                columns={columns}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard_Alumnos.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Dashboard_Alumnos)
